import {Injectable} from '@angular/core';
import {select, Store} from '@ngrx/store';
import {Actions, createEffect, ofType} from '@ngrx/effects';
import * as USER_DEVICE_ACTIONS from '../user-device-store/user-device.actions';
import {UserDeviceAndPermissionService} from '../service/user-device-permission/user-device-and-permission.service';
import {from, of} from 'rxjs';
import {catchError, map, mergeMap, withLatestFrom} from 'rxjs/operators';
import {selectUser} from '../user-store/user.selectors';
import {selectSelectedStore} from '../user-stores-store/user-store.selectors';
import {IGlobalError} from '../../../shared/shared-components/components/global-error-display/models/global-error';

@Injectable()
export class UserDeviceEffects {

  //#region [USER DEVICE][DEVICE] Get User Device User Agent
  getUserDeviceUserAgent$ = createEffect(() =>
    this.actions$.pipe(
      ofType(USER_DEVICE_ACTIONS.getUserDeviceUserAgent),
      withLatestFrom(
        this.store.pipe(select(selectUser)),
        this.store.pipe(select(selectSelectedStore)),
      ),
      mergeMap(([action, user, store]) => {
        try {
          const userAgent = this.userDeviceService.getUserAgentAndDeviceType();
          return of(USER_DEVICE_ACTIONS.getUserDeviceUserAgentSuccess({userAgent}));
        } catch (error) {
          return of(
            USER_DEVICE_ACTIONS.getUserDeviceUserAgentFailure({
              error: <IGlobalError>{
                ...error,
                action,
                actionType: action.type,
                originalError: error,
                storeIds: [store.storeId],
                userId: user.id,
              },
            }),
          );
        }
      }),
    ),
  );
  //#endregion

  //#region [USER DEVICE][PERMISSIONS] Get User Device Permissions
  getIsUserScreenRotationLocked$ = createEffect(() =>
    this.actions$.pipe(
      ofType(USER_DEVICE_ACTIONS.getUserDevicePermissions),
      withLatestFrom(
        this.store.pipe(select(selectUser)),
        this.store.pipe(select(selectSelectedStore)),
      ),
      mergeMap(([action, user, store]) =>
        from(this.userDeviceService.queryDevicePermissions()).pipe(
          map((permissions) =>
            USER_DEVICE_ACTIONS.getUserDevicePermissionsSuccess({permissions}),
          ),
          catchError((error) =>
            of(
              USER_DEVICE_ACTIONS.getUserDevicePermissionsFailure({
                error: <IGlobalError>{
                  ...error,
                  action,
                  actionType: action.type,
                  originalError: error,
                  storeIds: [store.storeId],
                  userId: user.id,
                },
              }),
            ),
          ),
        ),
      ),
    ),
  );


  //#endregion

  constructor(
    private actions$: Actions,
    private userDeviceService: UserDeviceAndPermissionService,
    private readonly store: Store,
  ) {
  }
}
